import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalRedefinirSenhaComponent } from './modal-redefinir-senha.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    ModalRedefinirSenhaComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,
    ReactiveFormsModule,
  ]
})
export class ModalRedefinirSenhaModule { }
